import { ShoppingCartIcon } from "@phosphor-icons/react/dist/ssr/ShoppingCart";
import { useEffect } from "react";

import {
  ApplicationStatus,
  type TApplicationStatus,
  sync,
  useProfile,
  useTheme,
} from "@up/data";
import { Animation, Spinner, Toast, ToastTitle, UPLink } from "@up/ui";

const StudentDenied = () => {
  return (
    <Toast size="large">
      <ToastTitle autoFocus={true} data-testid="application-thanks-heading">
        Thank you for applying
      </ToastTitle>
      We regret to inform you that we are unable to admit you into our program.
    </Toast>
  );
};

const StudentPending = () => {
  return (
    <Toast size="large" variant="success">
      <ToastTitle autoFocus={true} data-testid="application-thanks-heading">
        Thank you for applying.
      </ToastTitle>
      We have received your application and will share our decision via email
      within a few days.
    </Toast>
  );
};

const StudentApproved = () => {
  const theme = useTheme();

  return (
    <Toast size="large" variant="success" iconAlign="top">
      <ToastTitle autoFocus={true} data-testid="application-thanks-heading">
        Congratulations, you have been{" "}
        {theme.acceptOrAdmit === "accept" ? "accepted" : "admitted"} into our
        program!
      </ToastTitle>
      We look forward to seeing you.
      <div className="mt-2">
        <UPLink
          href="/checkout"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            borderBottom:
              "1px solid color-mix(in srgb, currentColor 50%, transparent)",
            paddingRight: "2px",
          }}
        >
          <ShoppingCartIcon size={20} /> Complete your enrollment now
        </UPLink>
      </div>
    </Toast>
  );
};

export function Thanks({ status }: { status: TApplicationStatus }) {
  const theme = useTheme();
  const profile = useProfile();
  const applicationBanner = (status?: TApplicationStatus) => {
    switch (status) {
      case ApplicationStatus.Approved:
        return <StudentApproved />;
      case ApplicationStatus.Denied:
        return <StudentDenied />;
      case ApplicationStatus.PendingReview:
        return <StudentPending />;
      default:
        return null;
    }
  };

  useEffect(() => {
    sync();
  }, []);

  if (profile.isLoading) {
    return (
      <div className="flex items-center justify-center gap-3">
        <Spinner /> Loading
      </div>
    );
  }

  return (
    <Animation type="splash-in">
      {applicationBanner(status)}

      {profile.contact?.scholarship ? null : (
        <>
          <br />
          <p className="mb-3">
            <span className="font-bold">
              Will you need financial support if admitted?
            </span>
          </p>
          <UPLink href="/scholarship" className={theme.buttonSecondaryClass}>
            Apply for a Need-Based Scholarship
          </UPLink>
          <br />
          <br />
        </>
      )}
    </Animation>
  );
}
